import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Icon, Tooltip } from '@electricjs/arc';

import { ROUTES } from '@/constants/routes';

export const WarehouseReassignmentIcon = () => {
  const { t } = useTranslation('assets');
  const message = t('assetDetails.reassignmentBlockedAtWarehouse');

  return (
    <Tooltip content={message} placement="top">
      <Link to={ROUTES.GET_HARDWARE} aria-label={message}>
        <Icon icon="warehouse" size="small" />
      </Link>
    </Tooltip>
  );
};
